import { TExperiment } from '../types/experiments';

export const getExperiment = (experiments?: TExperiment[], experimentName?: string): TExperiment | undefined => {
  return experiments && experiments.find(o => o.experimentName === experimentName);
};

// TODO: Раскомментировать, когда понадобится
// export function isExperimentActive(experiments: TExperiment[], experimentName: string, groupName: string): boolean {
//   const experiment = getExperiment(experiments, experimentName);

//   if (!experiment) {
//     return false;
//   }

//   return experiment.groupName === groupName;
// }
